import React from 'react';
import PropTypes from 'prop-types';
import { SnackbarProvider as Provider } from 'notistack';

const SnackbarProvider = ({ children }) => {
  return (
    <Provider
      hideIconVariant
      maxSnack={5}
      sx={{
        '.SnackbarItem-contentRoot': {
          backgroundColor: 'graphic.dark',
        },
        '.SnackbarItem-variantError': {
          backgroundColor: 'error.dark',
        },
        '.SnackbarItem-variantInfo': {
          backgroundColor: 'blue.dark',
        },
        '.SnackbarItem-variantSuccess': {
          backgroundColor: 'secondary.main',
        },
        '.SnackbarItem-variantVersion': {
          backgroundColor: 'yellow',
        },
        '.SnackbarItem-variantWarning': {
          backgroundColor: 'warning.dark',
        },
      }}
    >
      {children}
    </Provider>
  );
};

SnackbarProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default SnackbarProvider;
